import request from "./axios";

/**
 * 我的全部课程列表
 */
export function getMineCourse(pageNo, pageSize) {
    return request({
      url: "/api/teaching/teachingCourse/mineCourse?pageNo="+pageNo+"&pageSize="+pageSize,
      method: "get"
    });
  }
//获取课程信息
export function getCourseInfo(courseId){
  return request({
    url: "/api/teaching/teachingCourse/mineCourse?courseId="+courseId,
    method: "get"
  });
}

// 获取课程下的所有作业
// export function getCourseWorkInfo(courseId){
//   return request({
//     url: "/api/teaching/teachingCourse/getCourseWorkInfo?courseId="+courseId,
//     method: "get"
//   })
// }

//获取附加作业
export function mineAdditionalWork(){
  return request({
    url: "/api/teaching/teachingAdditionalWork/mineAdditionalWork",
    method: "get"
  })
}

/**
 * 获取课程单元
 */
export function getCourseUnit(departId, courseId, pageNo, pageSize) {
    return request({
      url: "/api/teaching/teachingCourseUnit/mineUnit",
      method: "get",
      params: {
        courseId,
        departId,
        pageNo,
        pageSize
      }
    });
  }
  
  /**
 * 获取课程单元下的课件
 */
export function getCourseCourseware(id) {
    return request({
      url:
        "/api/teaching/teachingCourseUnit/queryTeachingCourseUnitMediaRelByMainId",
      method: "get",
      params: {
        id
      }
    });
  }

/**
 * 记录学习日志
 */
export function studyLog(
  mediaId,
  mediaType,
  videoTime,
  progress,
  unitId,
  duration,
  finished,
  courseId
) {
  return request({
    url: "/api/teaching/teachingStudyLog/study",
    method: "get",
    params: {
      mediaId,
      mediaType,
      videoTime,
      progress,
      unitId,
      duration,
      finished,
      courseId
    }
  });
}
  

  /**
   * 获取我的评价
   */
  export function getMineReview(){
      return request({
          url: "/api/teaching/teachingWork/mineReview?pageSize=100",
          method: "get"
      })
  }

  /**
   * 最新开课的一节课
   */
  export function getNewCourse(){
    return request({
      url: "/api/teaching/teachingCourse/getNewCourse",
      method: "get"
    })
  }


// WEBPACK FOOTER //
// ./src/api/course.js